"use strict";
/**
 * Create routes in a laravelish way from a name and parameters
 *
 * @export
 * @class route
 */
Object.defineProperty(exports, "__esModule", { value: true });
;
function default_1(name, params = {}) {
    var routes = {
        'whats-on.index': '/whats-on',
        'proficiency-tests.current': '/spanish-level-test',
        'checkout.create': '/checkout/create'
    };
    if (typeof routes[name] === 'undefined') {
        return '';
    }
    var url_str = routes[name];
    if (params) {
        Object.entries(params).forEach(([param, val]) => {
            const needle = '{' + param + '}';
            if (url_str.indexOf(needle) !== -1) {
                url_str = url_str.replace(needle, val);
                delete params[param];
            }
        });
    }
    const url = new URL(`${window.location.origin}${url_str}`);
    Object.entries(params).forEach(([param, val]) => {
        url.searchParams.append(param, val);
    });
    return url.toString();
}
exports.default = default_1;
